<template>
  <el-dialog class="el-dialog-cus" v-bind="attributes" :visible.sync="visible" :before-close="handleClose"
    append-to-body :lock-scroll="false" :close-on-click-modal="false">
    <slot v-if="visibleSlot"></slot>
    <span v-if="diaText" class="diaText">{{ diaText }}</span>
    <div slot="footer">
      <el-button @click="
        queRen(cancel)
        " v-if="btnTxt[0]" type="primary">{{ btnTxt[0] }}</el-button>
      <el-button v-if="btnTxt[1]" @click="
        quXiao(),
        cancel()
        " plain>{{ btnTxt[1] }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    config: Object,
  },
  data() {
    const {
      width = '480px',
      title = '提示',
      txtcenter = false,
      btnTxt = [this.$fanyi('确定'), this.$fanyi('取消'), this.$fanyi('同意')],
    } = this.config || {}
    return {
      visible: false,
      attributes: {
        width,
        title,
        ...this.config,
      },
      btnTxt,
      visibleSlot: false,
      queRen: () => { },
      quXiao: () => { },
      diaText: null,
    }
  },
  methods: {
    open(text, queRen, quXiao) {
      this.diaText = text
      queRen ? (this.queRen = queRen) : ''
      quXiao ? (this.quXiao = quXiao) : ''
      this.visible = true
      this.visibleSlot = true

    },
    cancel() {
      this.visible = false
    },
    handleClose() {
      this.quXiao()
      this.cancel()
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../css/mixin.scss';

.el-dialog-cus {
  /deep/.el-dialog {
    background: #FFFFFF;
    border-radius: 20px;
    padding: 50px 40px;
  }

  /deep/.el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #121212;
    line-height: 20px;
  }

  /deep/.el-dialog__header {
    padding: 0px;
  }

  /deep/.el-dialog__body {
    padding: 0px;
    padding-top: 38px;
  }

  /deep/.el-dialog__footer {
    margin-top: 33px;
    padding: 0px;
    text-align-last: center;

    .el-button {
      padding: 0 10px;

      border-radius: 4px;
      font-size: 16px;
      min-width: 60px;
      height: 40px;

      border-radius: 10px;

      &:first-child {
        background: #D12A1D;
        color: #FFFFFF;
      }

      &:nth-child(2) {
        margin-left: 20px;
        background: #FFFFFF;
        border-radius: 10px;
        border: 1px solid #DFDFDF;
        font-weight: normal;
        font-size: 14px;
        color: #222222;
      }
    }
  }

  /deep/ .el-dialog__headerbtn {
    right: 20px;

    .el-icon-close {
      color: #000000 !important;
    }
  }

  .diaText {
    font-weight: 500;
    font-size: 16px;
    color: #121212;
    line-height: 20px;
    text-align: center;
    display: inline-block;
    word-break: break-word;
    /* 在单词之间换行 */
    width: 100%;

  }
}
</style>
